var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.242,
    height: 43.002,
    viewBox: "0 0 42.242 43.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(47.5 177.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M2.659,2.152H1.393a.127.127,0,0,0,0,.253H2.659a.127.127,0,0,0,0-.253Zm.253-.76H1.139a.127.127,0,1,0,0,.253H2.912a.127.127,0,1,0,0-.253ZM2.026,0A1.912,1.912,0,0,0,0,1.772,1.7,1.7,0,0,0,.76,3.155v.9l.887-.538a2.323,2.323,0,0,0,.379.032A1.912,1.912,0,0,0,4.051,1.772,1.912,1.912,0,0,0,2.026,0Zm0,3.292A2.049,2.049,0,0,1,1.6,3.245L1,3.6l.008-.587A1.468,1.468,0,0,1,.253,1.772,1.661,1.661,0,0,1,2.026.253,1.661,1.661,0,0,1,3.8,1.772,1.661,1.661,0,0,1,2.026,3.292Z",
    transform: "translate(-41.711 -157.082)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(-47 -177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M24.083,0c-.011.011-.034.011-.068.011A20.6,20.6,0,0,0,7.856,33.455l-3,6.977a1.12,1.12,0,0,0,.585,1.474,1.144,1.144,0,0,0,.641.079L17.095,40.05a19.854,19.854,0,0,0,6.864,1.193A20.621,20.621,0,0,0,24.083,0ZM23.97,39a18.063,18.063,0,0,1-6.358-1.159,1.079,1.079,0,0,0-.6-.056l-9.273,1.62L10.2,33.7a1.132,1.132,0,0,0-.18-1.182,17.99,17.99,0,0,1-3.128-5.2,18.373,18.373,0,1,1,35.481-6.8v.068A18.423,18.423,0,0,1,23.97,39Z",
    transform: "translate(-3.366)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(12.525 16.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M121.868,146.7h-6.077a1.125,1.125,0,1,0,0,2.251h6.077a1.125,1.125,0,1,0,0-2.251Z",
    transform: "translate(-114.666 -147.7)",
    fill: "#003358",
    stroke: "#003358",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(12.525 22.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M129.745,196.7H115.791a1.125,1.125,0,1,0,0,2.251h13.954a1.125,1.125,0,0,0,0-2.251Z",
    transform: "translate(-114.666 -194.7)",
    fill: "#003358",
    stroke: "#003358",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.dadc7518b38a2c6d1da8efd755e325cc.svg";
export { ForwardRef as ReactComponent };